import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button } from "@components/controls/Button"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { IconCaretRight } from "@components/svg/Icons"
import { getDateRange } from "@utils/dates"
import { Link } from "eddev/routing"
import { useMemo } from "react"
import { EventCardFragment } from "../../types.graphql"

type Props = EventCardFragment & {
  ctaLabel?: string
}

export function EventHeroCard(props: Props) {
  const range = useMemo(() => {
    return getDateRange(props.dates.flatMap((d) => [d.startDate, d.endDate]).filter((d): d is string => !!d))
  }, [props.dates])

  let ctaLabel = props.ctaLabel ?? "Details"

  return (
    <div className="@container">
      <Link href={props.uri} className="flex mb-7 text-pretty gap-4">
        <div className="flex-1">
          <RouteFlipped flipId={props.id!}>
            <ResponsiveImage {...props.hero?.image} />
          </RouteFlipped>
        </div>
        <div className="flex-1 stack-y-1 pt-3">
          <div className="stack-y-0">
            <div className="type-title-s-medium @[800px]:type-title-l-medium -mt-[0.3em] antialiased">{props.title}</div>
            <div className="type-title-s-roman @[800px]:type-title-l-roman">{range}</div>
          </div>
          <div className="pt-2 @[800px]:pt-3 type-body-s-roman @[800px]:type-body-l-roman">
            <div>{props.eventInfo?.location?.name}</div>
            <div>{props.eventInfo?.location?.address}</div>
          </div>
          <div className="mt-3 @[800px]:mt-4">
            <Button variant="charcoal" rightIcon={<IconCaretRight />}>
              {ctaLabel}
            </Button>
          </div>
        </div>
      </Link>
    </div>
  )
}
